var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "fullSize" },
    [
      _c(
        "v-row",
        { staticClass: "pb-3", attrs: { justify: "center", "no-gutters": "" } },
        [
          _c(
            "v-col",
            {
              staticClass: "pb-0 pt-0 px-3",
              staticStyle: { "max-height": "95px", "margin-bottom": "-1px" },
              attrs: { cols: "12", sm: "12" },
            },
            [
              _c("v-text-field", {
                staticClass: "inputSlot-mb-0",
                class: _vm.regexSearch
                  ? "text-field-top-details"
                  : "hide-error-message",
                staticStyle: { "z-index": "0" },
                attrs: {
                  value: _vm.searchSymbol,
                  outlined: "",
                  placeholder: _vm.regexSearch ? "Search with regex" : "Search",
                  "single-line": "",
                  dense: "",
                  rules: _vm.regexSearch ? [_vm.rules.validRegex] : [],
                  "hide-details": !_vm.regexSearch,
                },
                scopedSlots: _vm._u([
                  {
                    key: "append",
                    fn: function () {
                      return [
                        _c(
                          "v-row",
                          { staticClass: "mx-0" },
                          [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "mb-0 mx-2 pt-1 grey--text subtitle-2",
                              },
                              [_vm._v(" (" + _vm._s(_vm.currentSymbols) + ") ")]
                            ),
                            _c(
                              "v-btn",
                              {
                                staticClass: "mb-2",
                                attrs: {
                                  icon: "",
                                  small: "",
                                  color: _vm.regexSearch ? "primary" : "white",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.regexSearch = !_vm.regexSearch
                                  },
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "absolute",
                                    staticStyle: {
                                      left: "12px",
                                      "font-size": "17px",
                                    },
                                  },
                                  [_vm._v(" * ")]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "absolute",
                                    staticStyle: {
                                      left: "5px",
                                      "font-size": "25px",
                                      "margin-bottom": "2px",
                                    },
                                  },
                                  [_vm._v(" . ")]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.searchSymbol,
                  callback: function ($$v) {
                    _vm.searchSymbol = $$v
                  },
                  expression: "searchSymbol",
                },
              }),
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pt-0 px-3", attrs: { cols: "12" } },
            [
              _c("v-data-table", {
                ref: "PriceWatcherSymbolsTable",
                staticClass: "data-table-inside-footer",
                class: {
                  "cc-data-table-empty": !_vm.allPricewatcherSymbols.length,
                },
                staticStyle: {
                  height: "238px",
                  "overflow-y": "auto",
                  border: "1px solid #47bd96",
                  "z-index": "1",
                },
                attrs: {
                  id: "selectSymbolsTable",
                  dense: "",
                  "hide-default-header": "",
                  search: _vm.searchSymbol,
                  "custom-filter": _vm.symbolSearchFilter,
                  "items-per-page": 10,
                  items: _vm.allPricewatcherSymbols,
                  headers: [
                    { text: "", value: "value" },
                    { text: "", value: "alias", align: " d-none" },
                  ],
                  "footer-props": {
                    "items-per-page-options": [10, 25, 50, 100, -1],
                  },
                },
                on: {
                  "current-items": (items) => _vm.setCurrentSymbols(items),
                },
                scopedSlots: _vm._u([
                  {
                    key: "no-data",
                    fn: function () {
                      return [
                        _c(
                          "v-row",
                          { attrs: { justify: "center" } },
                          [
                            _vm.loadingPWSymbols
                              ? _c(
                                  "v-col",
                                  { attrs: { cols: "2" } },
                                  [
                                    _c(
                                      "v-row",
                                      { attrs: { justify: "end" } },
                                      [
                                        _c("v-progress-circular", {
                                          staticStyle: { "margin-top": "-4px" },
                                          attrs: {
                                            indeterminate: "",
                                            color: "primary",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "v-col",
                              {
                                attrs: { cols: _vm.loadingPWSymbols ? 5 : 10 },
                              },
                              [
                                _c(
                                  "p",
                                  {
                                    style: _vm.loadingPWSymbols
                                      ? "text-align: left;"
                                      : "text-align: center;",
                                  },
                                  [_vm._v(" " + _vm._s(_vm.tableMessage) + " ")]
                                ),
                                !_vm.loadingPWSymbols
                                  ? _c(
                                      "v-btn",
                                      {
                                        staticStyle: { "font-weight": "400" },
                                        attrs: {
                                          rounded: "",
                                          outlined: "",
                                          color: "primary",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.$router.push({
                                              path: "/applications",
                                              query: { add: true },
                                            })
                                          },
                                        },
                                      },
                                      [_vm._v("Run Applications")]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "item",
                    fn: function ({ item }) {
                      return [
                        _c("tr", { staticClass: "accent" }, [
                          _c(
                            "td",
                            { staticClass: "primary--text py-1" },
                            [
                              _c(
                                "v-row",
                                { staticClass: "mx-0" },
                                [
                                  _c(
                                    "div",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.symbolSelected(item)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "v-row",
                                        { staticClass: "mx-0" },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              staticClass: "mt-2",
                                              attrs: { color: "primary" },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    item.checked
                                                      ? "radio_button_checked"
                                                      : "radio_button_unchecked"
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "ml-1",
                                              staticStyle: {
                                                width: "108px",
                                                "margin-top": "10px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " + _vm._s(item.value) + " "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c("v-text-field", {
                                    staticClass: "mini-text-field",
                                    class: {
                                      "ml-6":
                                        _vm.$vuetify.breakpoint.width > 500,
                                    },
                                    staticStyle: {
                                      "max-width": "100px",
                                      height: "28px",
                                      "margin-bottom": "6px",
                                    },
                                    attrs: {
                                      disabled: !item.checked,
                                      label: "Alias",
                                      dense: "",
                                      "hide-details": "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                      },
                                    },
                                    model: {
                                      value: item.alias,
                                      callback: function ($$v) {
                                        _vm.$set(item, "alias", $$v)
                                      },
                                      expression: "item.alias",
                                    },
                                  }),
                                  _c("v-text-field", {
                                    staticClass: "mini-text-field",
                                    class:
                                      _vm.$vuetify.breakpoint.width > 500
                                        ? "ml-8"
                                        : "ml-1",
                                    staticStyle: {
                                      "max-width": "100px",
                                      height: "28px",
                                      "margin-bottom": "6px",
                                    },
                                    attrs: {
                                      disabled: !item.checked,
                                      type: "number",
                                      label: "Spread Multiplier",
                                      dense: "",
                                      "hide-details": "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                      },
                                    },
                                    model: {
                                      value: item.multiplier,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          item,
                                          "multiplier",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression: "item.multiplier",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        { staticClass: "mx-0 pl-3", attrs: { justify: "start" } },
        [
          _c(
            "v-btn",
            {
              staticStyle: { "font-weight": "400" },
              attrs: {
                disabled: !_vm.allPricewatcherSymbols.length,
                color: "primary",
                text: "",
              },
              on: { click: _vm.selectAll },
            },
            [_vm._v("Add All ")]
          ),
          _c(
            "v-btn",
            {
              staticStyle: { "font-weight": "400" },
              attrs: {
                disabled: !_vm.allPricewatcherSymbols.length,
                color: "primary",
                text: "",
              },
              on: { click: _vm.deSelectAll },
            },
            [_vm._v("Remove All ")]
          ),
          _c("p", { staticClass: "mb-0 mx-4 pt-2 grey--text subtitle-2" }, [
            _vm._v(
              " Selected: " +
                _vm._s(_vm.currentSelectedSymbols) +
                "/" +
                _vm._s(_vm.currentSymbols) +
                _vm._s(
                  _vm.allPricewatcherSymbols.length > _vm.currentSymbols
                    ? `   Total selected: ${_vm.checkedSymbolsCount}/${_vm.allPricewatcherSymbols.length}`
                    : ""
                ) +
                " "
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }